import s from './not-found-page.module.scss';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import Icon404 from 'public/icons/404/404.svg';
import { Button } from '@/ui/button/button';

const NotFoundPage = () => {
  const t = useTranslations('NotFound');

  const { push } = useRouter();

  const handleGoHome = () => push('/');

  return (
    <section className={s.notFound}>
      <Icon404 />

      <div className={s.info}>
        <h1>{t('pageTitle')}</h1>
        <p>{t('pageDescription')}</p>
        <Button size="large" onClick={handleGoHome}>
          {t('ctaBtn')}
        </Button>
      </div>
    </section>
  );
};

export default NotFoundPage;
